import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxDirective } from './checkbox.directive';
import { CheckboxComponent } from './checkbox.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    CheckboxDirective,
    CheckboxComponent,
  ],
  exports: [
    CheckboxDirective,
    CheckboxComponent,
  ],
})
export class CheckboxModule { }



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/checkbox/checkbox.module.ts